import { useSelectedOrganizationLanguages } from "../../hooks/useSelectedOrganizationLanguages";

/**
 * The app-level reader of the selected organisation's language settings
 * (`useSelectedOrganizationLanguages`). It draws nothing; the app mounts it
 * once while someone is signed in.
 */
export function OrganizationLanguagesReader(): null {
    useSelectedOrganizationLanguages();
    return null;
}
